export const SHOW_GLOBAL_TOOLTIP = 'SHOW_GLOBAL_TOOLTIP';
export const HIDE_GLOBAL_TOOLTIP = 'HIDE_GLOBAL_TOOLTIP';
export const UPDATE_GLOBAL_TOOLTIP = 'UPDATE_GLOBAL_TOOLTIP';



// WEBPACK FOOTER //
// ../../src/tooltip/events.js